BaseDirectoryView = require './base-directory-view'
t = require 'recup'
React = require 'react'

class DirectorySpinner extends React.Component
  displayName: 'Directory Spinner'

  render: t.renderable ->
    t.div '.directory-spinner', ->
      t.div '.spinner.loading.centered'

module.exports = class DirectorySpinnerView extends BaseDirectoryView
  renderContent: ->
    React.createElement DirectorySpinner



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-spinner-view.coffee